/* ============================================
   sesion.ts — Manejo centralizado de la sesión vencida

   El JWT dura 7 días. Cuando vence, TODAS las llamadas empiezan a devolver 401
   y, sin este manejo, cada pantalla mostraba su propio error genérico ("Error al
   cargar mensajes", tablas vacías, contadores en cero). El sistema parecía roto
   cuando en realidad solo había que volver a entrar.
   ============================================ */

const CLAVE_TOKEN = 'auth_token'
export const MOTIVO_SESION_EXPIRADA = 'sesion_expirada'

/** Evita disparar varias redirecciones cuando 401 llegan en paralelo. */
let redirigiendo = false

/**
 * Cierra la sesión local y manda al login avisando por qué.
 * Se llama desde los clientes HTTP al recibir un 401.
 */
export function cerrarSesionPorExpiracion(): void {
  if (redirigiendo) return
  redirigiendo = true

  try {
    localStorage.removeItem(CLAVE_TOKEN)
    sessionStorage.setItem(MOTIVO_SESION_EXPIRADA, '1')
  } catch {
    // Modo privado o storage bloqueado: la redirección igual tiene que ocurrir.
  }

  // Si ya estamos en el login no hace falta navegar (evita un bucle de recargas).
  if (window.location.pathname !== '/login') {
    window.location.assign('/login')
  } else {
    redirigiendo = false
  }
}

/** true una sola vez: el login lo consume para mostrar el aviso. */
export function consumirAvisoSesionExpirada(): boolean {
  try {
    const hubo = sessionStorage.getItem(MOTIVO_SESION_EXPIRADA) === '1'
    if (hubo) sessionStorage.removeItem(MOTIVO_SESION_EXPIRADA)
    return hubo
  } catch {
    return false
  }
}

/**
 * Un 401 solo significa "sesión vencida" si estábamos autenticados. Sin token es
 * una llamada pública mal hecha, y ahí redirigir escondería el bug real.
 */
export function esSesionVencida(status: number): boolean {
  if (status !== 401) return false
  try {
    return Boolean(localStorage.getItem(CLAVE_TOKEN))
  } catch {
    return false
  }
}
